import jQuery from "jquery";
import "popper.js";
import "bootstrap";

window.$ = window.jQuery = jQuery;
